import { IframeMessageToChild } from '@app/types';

/** Send a message to a child that we are iframing into this app. */
export function sendIframeMessageToChild(
  element: HTMLIFrameElement,
  message: IframeMessageToChild
) {
  element.contentWindow?.postMessage(message, '*');
}
